import { StatusChip } from "../common/StatusChip";
import { getFlagMeta } from "../../utils/statusMeta";

export const CardUserNetwork = ({ user, monthlyPoints = 0 }) => {
  const members = Array.isArray(user?.user_network) ? user.user_network : [];
  const directs = members.filter((n) => n.level === 1).length;
  const active = members.filter((n) => n.network_status).length;
  const bonusMeta = getFlagMeta(user?.network?.influencer_bonus_status);
  const royaltyMeta = getFlagMeta(user?.network?.loyalty_status);

  return (
    <div className="ui-card">
      <div style={{ display: "flex", alignItems: "center", gap: 9, marginBottom: 16 }}>
        <i className="ri-team-line" style={{ color: "#4B36F0", fontSize: 17 }} />
        <h3 style={{ margin: 0, fontSize: 15, fontWeight: 700 }}>Red</h3>
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "14px 10px" }}>
        <div>
          <div style={{ color: "#8A91AE", fontSize: 11.5 }}>Directos</div>
          <div style={{ fontSize: 18, fontWeight: 800, marginTop: 2 }}>{directs}</div>
        </div>
        <div>
          <div style={{ color: "#8A91AE", fontSize: 11.5 }}>Red total</div>
          <div style={{ fontSize: 18, fontWeight: 800, marginTop: 2 }}>{members.length}</div>
        </div>
        <div>
          <div style={{ color: "#8A91AE", fontSize: 11.5 }}>Activos</div>
          <div style={{ fontSize: 18, fontWeight: 800, marginTop: 2, color: "#0F9A5A" }}>{active}</div>
        </div>
        <div>
          <div style={{ color: "#8A91AE", fontSize: 11.5 }}>Puntos del mes</div>
          <div style={{ fontSize: 18, fontWeight: 800, marginTop: 2, color: "#4B36F0" }}>{monthlyPoints}</div>
        </div>
      </div>

      <div style={{ display: "flex", gap: 9, marginTop: 16, paddingTop: 14, borderTop: "1px solid #F1F3F9", flexWrap: "wrap" }}>
        <StatusChip tone={bonusMeta.tone} icon={bonusMeta.icon}>Bono {bonusMeta.label.toLowerCase()}</StatusChip>
        <StatusChip tone={royaltyMeta.tone} icon={royaltyMeta.icon}>Regalía {royaltyMeta.label.toLowerCase()}</StatusChip>
      </div>
    </div>
  );
};
